window.addEventListener("DOMContentLoaded", function () {
    let placeholder;
    let isDraggingStarted = false;
    let draggedElement;
    let x = 0;
    let y = 0;
    let holdTimer;

    const swap = function (nodeA, nodeB) {
        const parentA = nodeA.parentNode;
        const siblingA = nodeA.nextSibling === nodeB ? nodeA : nodeA.nextSibling;

        // Move nodeA to before the nodeB
        nodeB.parentNode.insertBefore(nodeA, nodeB);

        // Move nodeB to before the sibling of nodeA
        parentA.insertBefore(nodeB, siblingA);
    };

    const mouseDownHandler = function (e) {
        x = e.pageX;
        y = e.pageY;

        // Attach the listeners to document
        document.addEventListener('mousemove', mouseMoveHandler);
    };

    const mouseMoveHandler = function (e) {
        if (!isDraggingStarted) {
            isDraggingStarted = true;

            // Let the placeholder take the height of dragging element
            // So the next element won't move up
            placeholder = document.createElement('div');
            placeholder.classList.add('placeholder');
            draggedElement.parentNode.insertBefore(
                placeholder,
                draggedElement.parentNode.querySelector('.intermediate-delete-icon')
            );
        }

        // Set position for dragging element
        draggedElement.style.position = 'absolute';
        draggedElement.style.zIndex = '999';
        draggedElement.style.top = (e.pageY - y) + 'px';
        draggedElement.style.left = (e.pageX - x) + 'px';
    };

    const mouseUpHandler = function (e) {
        const point = {
            x: e.pageX,
            y: e.pageY
        };
        const steps = document.querySelectorAll('.roadtrip-step.draggable');
        const stepsPoints = [];

        steps.forEach((el) => {
            const box = el.getBoundingClientRect();
            stepsPoints.push({
                el,
                x: (box.left + box.right) / 2,
                y: (box.top + box.bottom) / 2
            })
        });

        const distance = (p) => {
            return Math.sqrt(Math.pow(point.x - p.x, 2) + Math.pow(point.y - p.y, 2))
        }
        const closest = stepsPoints.reduce((a, b) => distance(a) < distance(b) ? a : b);

        if (closest) {
            const el = closest.el.querySelector('.mapbox-autocomplete-field');
            if (el) {
                swap(el, draggedElement);
            }
        }

        // Remove the placeholder
        placeholder && placeholder.parentNode.removeChild(placeholder);

        draggedElement.style.removeProperty('top');
        draggedElement.style.removeProperty('left');
        draggedElement.style.removeProperty('position');

        x = null;
        y = null;
        draggedElement = null;
        isDraggingStarted = false;

        // Remove the handlers of mousemove and mouseup
        document.removeEventListener('mousemove', mouseMoveHandler);

        if (holdTimer) {
            clearTimeout(holdTimer);
            holdTimer = null;
        }
    };

    document.addEventListener("mousedown", function(e){
        const target = e.target.closest(".draggable");

        if(target) {
            draggedElement = target.querySelector('.mapbox-autocomplete-field');

            holdTimer = setTimeout(mouseDownHandler, 500, e);
        }
    });

    document.addEventListener('mouseup', (e) => {
        if (holdTimer) {
            clearTimeout(holdTimer);
            holdTimer = null;
        }

        if (isDraggingStarted) {
            mouseUpHandler(e);
            window.updateRoadtripStorage();
            window.addWaypointsToMapbox();
        }
    });
});